import { List, Map, fromJS } from 'immutable'


const initDocumentDetail = fromJS({
	file_attachment:[],
})


export function documentAttachment(state = initDocumentDetail, action) {
	switch(action.type) {
		case 'DOCUMENT_ADD_FILE_ATTACHMENT_SUCCESS':
				return state.set('file_attachment', fromJS(action.file_attachment))
		default:
			return state
	}
}